import { useAxiosInstance } from "./axios";
import { END_POINTS } from "./END_POINTS";

export type NewsType = {
  data: {
    news: {
      id: number;
      title: string;
    }[];
    main_text: string;
  };
};

export const useGetNews = () => {
  const axios = useAxiosInstance();
  return axios.get(END_POINTS.NEWS_LIST);
};

export type NewsListType = {
  data: {
    news_id: number;
    news_title: string;
    title: string;
    url: string;
    published_date: string;
    content: string;
    description: string;
  }[];
};

export const useGetNewsList = () => {
  const axios = useAxiosInstance();

  const handleGetNewsList = (id: string | number) => {
    return axios.get(END_POINTS.NEWS_ITEM(id));
  };

  return handleGetNewsList;
};

export type NewsSearch = {
  data: {
    news_id: number;
    news_title: string;
    title: string;
    url: string;
    published_date: string;
    content: string;
    description: string;
  }[];
};

export const useGetSearchedNews = () => {
  const axios = useAxiosInstance();

  const handleSearch = (keyword: string) => {
    const form = new FormData();
    form.append("key_word", keyword);

    return axios.post(END_POINTS.SEARCH_NEWS_ITEM, form);
  };

  return handleSearch;
};
